"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isReactNative = require('@padlet/platform').isReactNative;

var pixelRatio = 2;

if (isReactNative) {
  var PixelRatio = require('react-native').PixelRatio;

  pixelRatio = Math.ceil(PixelRatio.get());
} else if (typeof window !== 'undefined' && window.devicePixelRatio !== undefined) {
  pixelRatio = Math.ceil(window.devicePixelRatio);
}

exports.default = pixelRatio;